import { useEffect, useState } from "react";
import UserBookStatusFragmentCompiled from "queries/user_books/fragments/UserBookStatusFragmentCompiled";
import { UserBookStatusType } from "types/UserBookType";
import { useFragment } from "lib/apollo/client";
import useCurrentUserId from "hooks/user/useCurrentUserId";

export default function useUserBookStatus(bookId: number) {
  const userId = useCurrentUserId();
  const [userBook, setUserBook] = useState<UserBookStatusType>({
    userId,
    bookId,
    statusId: 0,
  });
  const { data } = useFragment({
    fragment: UserBookStatusFragmentCompiled,
    fragmentName: "UserBookStatusFragment",
    from: {
      __typename: "user_books",
      bookId,
      userId: userId || 0,
    },
  });

  useEffect(() => {
    setUserBook(
      data?.userId
        ? data
        : {
            userId,
            bookId,
            statusId: 0,
          }
    );
  }, [userId, data, bookId]);

  return userBook;
}
